export const LANG_KEY = "synthconst_lang";
export function getLang() { return localStorage.getItem(LANG_KEY) || "en"; }
export function setLang(lang) { localStorage.setItem(LANG_KEY, lang); }
